/* eslint-disable react/no-multi-comp */
import React from 'react';
import { GeoJSON, Pane } from 'react-leaflet';
import { Polyline, Circle } from 'react-leaflet';
import { UavMarker } from './UavMarker';

import { SegmentedPolyline } from './SegmentedPolyline';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  subscribeToSpecificAircraft,
  subscribeToLiveAircraft
} from 'actions/liveAircraftActions';
import { missionPointsCollectionToPolyline } from '../../../utils/parsingUtils';

import { Pilots } from 'views/Aerospace/components/Pilots/Pilots';
import { indexPriority } from 'utils/ui';
import { getUavLIcon } from '../../../constants';
import { selectHoverAircraft } from '../../../selectors/ordersSelector';
const maxZoom = 24;

export const UavMapElement = props => {
  const uavs = useSelector(state => state.liveAircraft.liveData);
  const hoverAircraft = useSelector(selectHoverAircraft);
  const showGeotunnels = useSelector(
    state => state.liveAircraft.showGeotunnels
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (props.live) {
      dispatch(subscribeToLiveAircraft());
    } else if (props.uavs) {
      dispatch(subscribeToSpecificAircraft(props.uavs));
    }
    return () => {};
  }, []);

  const uavData = Object.values(uavs)?.filter(uav => {
    if (props.sitl) {
      return true;
    } else {
      return !uav?.sitl;
    }
  });

  const pilotDataArr = uavData.map(uav => {
    return { uavId: uav.uavId, pilotInfo: uav?.pilotInfo, uav };
  });

  if (!uavData?.length) return null;

  return (
    <>
      {uavData?.map(uav => {
        if (!uav) return null;

        const { route, uavState, currentPosition, mission } = uav;

        const missionRoute = missionPointsCollectionToPolyline(
          mission?.geoJson
        );
        const isHovered = hoverAircraft?.replace('MNA-', '') === uav.uavId;

        const col = getUavLIcon(uavState, uav?.stale, isHovered, 'small');
        return (
          <div key={`${uav.uavId}div1${uavState}-${isHovered}`}>
            <Pane
              key={`${uav.uavId}pane1`}
              name={`${uav.uavId}pane1`}
              style={{
                zIndex: indexPriority(2)
              }}>
              <Circle
                key={`${uav.uavId}circle`}
                center={currentPosition}
                radius={30}
                stroke={0}
                style={{
                  zIndex: indexPriority(3)
                }}
                fillColor={
                  ['MANUAL', 'MISSION', 'ABORT'].includes(uavState)
                    ? 'red'
                    : 'blue'
                }
              />
            </Pane>
            <Pane
              key={`${uav.uavId}pane2`}
              name={`${uav.uavId}pane2`}
              style={{
                zIndex: indexPriority(1)
              }}>
              <div key={`${uav.uavId}div`}>
                {route && (
                  <SegmentedPolyline
                    key="SegmentedPolyline"
                    route={route}
                    maxZoom={maxZoom}
                  />
                )}
                {missionRoute && (
                  <>
                    <Polyline
                      positions={missionRoute}
                      key={'Polyline1'}
                      weight={1}
                    />
                    {props.geotunnel && showGeotunnels && mission?.geoTunnel && (
                      <>
                        <GeoJSON
                          data={mission.geoTunnel}
                          style={{ fill: true }}
                          key={mission?.missionId}
                          weight={1}
                        />
                      </>
                    )}
                  </>
                )}
                {currentPosition && (
                  <>
                    <UavMarker
                      key={`${uav.uavId}fjhew8897ty`}
                      position={currentPosition}
                      heading={uav.compass}
                      icon={col}
                    />
                  </>
                )}

                {props.pilots && <Pilots p2 key="Pilots" data={pilotDataArr} />}
              </div>
            </Pane>
          </div>
        );
      })}
    </>
  );
};
